import React from 'react';
import PropTypes from 'prop-types';
import ModuleBlock from '../ModuleBlock';
import ModuleService from '../../../../../services/module';

class AccessTokenModuleBlock extends React.Component {
    static propTypes = {
        app: PropTypes.object.isRequired,
    };

    render() {
        return (
            <ModuleBlock
                app={this.props.app}
                module={ModuleService.getModule(ModuleService.ACCESS_TOKEN)}
            />
        );
    }
}

export default AccessTokenModuleBlock;



// WEBPACK FOOTER //
// src/components/application/ApplicationFull/ModuleBlock/AccessTokenModuleBlock/AccessTokenModuleBlock.js